import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { checkValidity } from '../../helpers/helpers.js'

// Translations
import translate from '../Translate.js';

// Dependencies
import Textarea from 'react-textarea-autosize';

const MessagesDetail = observer(class MessagesDetail extends React.Component {
  handleSubmit(e) {
    e.preventDefault();
  }

  render() {
    return(
      <div className="drawer__content">
        <header className="drawer__header">
          <div className="wrap">
            <h1 className="drawer__title">Message subject goes here…</h1>
          </div>
        </header>

        <div className="wrap">
          <ol className="conversation">
            <li>
              <blockquote className="conversation__message">
                <div className="conversation__body">
                  <div className="conversation__content">
                    Maecenas faucibus mollis interdum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros. Nullam id dolor id nibh ultricies vehicula ut id elit.
                  </div>
                  <time className="conversation__timestamp">5/28/2017 10:00am</time>
                </div>

                <cite className="conversation__author">
                  <img className="conversation__avatar avatar" src="https://fillmurray.com/200/200" alt="Chim Richalds’s avatar" />

                  <strong>Chim Richalds</strong>
                </cite>
              </blockquote>
            </li>
            <li>
              <blockquote className="conversation__message">
                <div className="conversation__body">
                  <div className="conversation__content">
                    Maecenas faucibus mollis interdum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros. Nullam id dolor id nibh ultricies vehicula ut id elit.
                  </div>
                  <time className="conversation__timestamp">5/28/2017 11:00am</time>
                </div>

                <cite className="conversation__author">
                  <img className="conversation__avatar avatar" src="https://fillmurray.com/300/300" alt="Chim Richalds’s avatar" />

                  <strong>Mike Rithgen</strong>
                </cite>
              </blockquote>
            </li>
            <li>
              <blockquote className="conversation__message">
                <div className="conversation__body">
                  <div className="conversation__content">
                    Maecenas faucibus mollis interdum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros. Nullam id dolor id nibh ultricies vehicula ut id elit.
                  </div>
                  <time className="conversation__timestamp">5/28/2017 10:00am</time>
                </div>

                <cite className="conversation__author">
                  <img className="conversation__avatar avatar" src="https://fillmurray.com/200/200" alt="Chim Richalds’s avatar" />

                  <strong>Chim Richalds</strong>
                </cite>
              </blockquote>
            </li>
            <li>
              <blockquote className="conversation__message">
                <div className="conversation__body">
                  <div className="conversation__content">
                    Maecenas faucibus mollis interdum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros. Nullam id dolor id nibh ultricies vehicula ut id elit.
                  </div>
                  <time className="conversation__timestamp">5/28/2017 11:00am</time>
                </div>

                <cite className="conversation__author">
                  <img className="conversation__avatar avatar" src="https://fillmurray.com/300/300" alt="Chim Richalds’s avatar" />

                  <strong>Mike Rithgen</strong>
                </cite>
              </blockquote>
            </li>
          </ol>

          <form className="reply__form" onSubmit={(e) => checkValidity(e, this.handleSubmit)} noValidate>
            <div className="panel--medium">
              <fieldset>
                <ul className="fields">
                  <li>
                    <label className="meta" htmlFor="ticket-comment">Reply</label>
                    <Textarea
                      id="ticket-comment"
                      className="textarea-grow"
                      placeholder="Send your reply…"
                      required
                      aria-required="true"
                    ></Textarea>
                  </li>
                </ul>
              </fieldset>

              <button className="btn" type="submit">Send Reply</button>
            </div>
          </form>
        </div>
      </div>
    )
  }
})

export default translate('MessagesDetail')(MessagesDetail);


// WEBPACK FOOTER //
// ./src/app/components/Messages/MessagesDetail.js